import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/components/administration"

export const pageConfig: AdministrationContentPage = {
  id: "sms",
  title: "SMS-Vorlagen",
  path: "sms",
  tabs: [
    ["announcement", "Ankündigung"],
    ["reschedule", "Verschiebung"],
  ].map(([purpose, title]) => ({
    id: `sms-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.sms.${purpose}`,
  })),
}
